import { observable, configure, action } from 'mobx';
import LocalModel from './localModel';
import util from 'preact-util';

configure({ enforceActions: 'always' });

class AnimalHealthRecordStore extends LocalModel {
    constructor() {
        super('animalHealthRecord', {
            namePlural: 'animalHealthRecords',
            namePluralReal: 'animalhealthrecords',
            sort: '-visitDate',
            limit: 100,
            api: {
                search: {
                    url: '/api/animalhealthrecords/',
                    params: {
                        limit: 100,
                        sort: '-visitDate',
                    },
                },
                load: {
                    url: '/api/animalhealthrecords/',
                    params: {},
                },
                save: {
                    url: '/api/animalhealthrecords/',
                    params: {},
                },
                delete: {
                    url: '/api/animalhealthrecords/',
                    params: {},
                },
            },
        });
    }

    @observable animalHealthRecords = [];
    @observable animalHealthRecord = {};

    @action
    async loadByAnimal(animalId) {
        const response = await util.fetchApi('/api/animalhealthrecords/', { method: 'GET' }, { animal: animalId });
        if (response?.status === 200) {
            this.updateKeyValue('animalHealthRecords', response.data || []);
        } else {
            this.updateKeyValue('animalHealthRecords', []);
        }
        return response;
    }
}

const store = new AnimalHealthRecordStore();
export default store;
